import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
// import Header from '../../components/Layout/Header';
// import navImg1 from '../../assets/images/resources/logo-1.png';
// import Footer from '../../components/Layout/Footer';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
// import bannerbg from '../../assets/images/backgrounds/page-header-bg.jpg';
import bannerbg from "../../../src/assets/images/resources/contact2.jpg"
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import ContactMain from './ContactMain';
import HeaderStyleTwo from '../../components/Layout/Header/HeaderStyleTwo';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';

// Breadcrumbs Background Image

const Contact = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <React.Fragment>
        {/* <Header
            navImg={navImg1}
            parentMenu='contact'
            activeMenu="/contact"
        /> */}
       <HeaderStyleTwo/>
        {/* SiteBreadcrumb */}
        <SiteBreadcrumb
            pageTitle="Contact"
            pageName="Contact"
            breadcrumbsImg={bannerbg}
        />
        {/* SiteBreadcrumb */}
        <ContactMain/>
        {/*cta-section */}
        <CtaTwo/>
        {/*cta-section end */}
        <BackToTop scroll={isVisible} />
       <FooterTwo/>
    </React.Fragment>
    );
}

export default Contact;